/*
 * Public API Surface of ng-select
 */

export { DropdownPosition, NgSelectComponent, SELECTION_MODEL_FACTORY } from './lib/ng-select.component';
export { NgSelectModule } from './lib/ng-select.module';
export { NgOption } from './lib/ng-select.types';
export { SelectionModel } from './lib/selection-model';
export { NgSelectConfig } from './lib/config.service';
